import React from 'react';
import { Box, Table, Thead, Tbody, Tr, Th, Td, Text } from '@chakra-ui/react';
interface PricingRow {
  label: string;
  value: string | React.ReactNode;
}
interface PricingTableProps {
  rows: PricingRow[];
}
export function PricingTable({
  rows
}: PricingTableProps) {
  return <Box overflowX="auto" borderWidth="1px" borderColor="red.800" borderRadius="lg" bg="rgba(0, 0, 0, 0.4)" shadow="xl" data-id="element-233">
      <Table variant="simple" size={{
      base: 'sm',
      md: 'md'
    }} data-id="element-234">
        <Tbody data-id="element-235">
          {rows.map((row, index) => <Tr key={index} _hover={{
          bg: 'rgba(127, 29, 29, 0.2)'
        }} borderBottomWidth="1px" borderBottomColor="red.900" data-id="element-236">
              <Td fontWeight="semibold" color="red.200" whiteSpace="normal" fontSize={{
            base: 'xs',
            md: 'sm'
          }} py={{
            base: 3,
            md: 4
          }} px={{
            base: 3,
            md: 4
          }} data-id="element-237">
                {row.label}
              </Td>
              <Td color="gray.300" fontWeight="medium" fontSize={{
            base: 'xs',
            md: 'sm'
          }} py={{
            base: 3,
            md: 4
          }} px={{
            base: 3,
            md: 4
          }} data-id="element-238">
                {row.value}
              </Td>
            </Tr>)}
        </Tbody>
      </Table>
    </Box>;
}